const collectionsSwipers = [];
const swiperContainers = document.querySelectorAll(".collections-swiper-inner-wrapper");

swiperContainers.forEach((item,index ) => {
  const id = item.id;
  const swiper = new Swiper(`#${id} .swiper`, {
    slidesPerView: 1.3,
    spaceBetween: "12px",
    breakpoints: {
      500: { slidesPerView: 2.3, spaceBetween: "20px" },
      680: { slidesPerView: 2.8 },
      1024: { slidesPerView: 4 },
      1400: { slidesPerView: 5 },
    },
    navigation: {
      nextEl: `#${id} .next`,
      prevEl: `#${id} .prev`,
    },
  });

  swiper.on("breakpoint",handleDisabledNavigation)
  handleDisabledNavigation() //initial check
  function handleDisabledNavigation(){
    setTimeout(() => { 
      let isBothNavigationDisabled = false
      const navItems = Array.from(document.querySelectorAll(`#${id} .nav`))
      const shouldHideNav = navItems.map((nav) => nav.classList.contains("swiper-button-disabled")).every((val) => val)
      const nav = document.querySelector(`#${id} .collections-swiper-navigation`)
      nav.style.display = shouldHideNav ? "none" : ""
    },0)
  }
  collectionsSwipers.push(swiper);
});

const swiperHandles = document.querySelectorAll("*[data-target-swiper]");
swiperHandles.forEach((handle) =>
  handle.addEventListener("click", () => {
    const targetSwiperIdentifier = handle.dataset.targetSwiper;
    const targetSwiperContainer = document.querySelector(
      `div[data-swiper-for='${targetSwiperIdentifier}']`
    );
    const headerOffset =
      parseInt(
        getComputedStyle(document.body).getPropertyValue("--header-height")
      ) + 16;
    const elementPosition = targetSwiperContainer.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  })
);

const cardButtons = document.querySelectorAll(".collections-card-button")
cardButtons.forEach((button) => {
  button.addEventListener("click",(e) => {
    e.preventDefault();
    const makeModel = button.dataset.makeModel 
    const make = makeModel.split(" ")[0]
    localStorage.setItem("makeModel", JSON.stringify({make,model:makeModel}));
    window.location.href = event.target.href;
  })
})